import axios from 'axios'


const BASE_URL = process.env.REACT_APP_API_URL;
const MASTER_GET_URL = BASE_URL + "/master";
const MASTER_DELETE_URL = BASE_URL + "/master/";
const MASTER_ADD_URL = BASE_URL + "/master";
const MASTER_EDIT_URL = BASE_URL + "/master/";
const PRODUCT_REMOVE_URL = BASE_URL + "/master/remove-products";

const RESTORE_PRODUCT_URL = BASE_URL + "/master/restore";
const SYNC_ATTRIBUTE_URL = BASE_URL + "/master/syncAttribute/";


export const getMaster = (searchParams?: string) => {
    return axios.get(MASTER_GET_URL + "?" + searchParams);
  };


  export const getSingleMaster = (productid: string) => {
    return axios.get(MASTER_GET_URL + "/" + productid);
  };


  export const deleteMaster = (productid: string) => {
    return axios.delete(MASTER_DELETE_URL + productid);
  };


 export const removeProduct = (masterId: string, productIds: string[]) => {
    return axios.patch(PRODUCT_REMOVE_URL, {
        masterId: masterId,
        ids: productIds
    });
};


  export const addMaster = (payload: any) => {
    return axios.post(MASTER_ADD_URL, payload);
  };

  export const editMaster = (payload: any, productid: string) => {
    return axios.patch(MASTER_EDIT_URL + productid, payload);
  };


 
  export const updateStatus = (product: any) => {
    const url = MASTER_EDIT_URL + product._id;
    
    const payload = {
    
    };
  
    if (product._id) {
      return axios.patch(url, payload);
    }
  };

  export const getProductGroupByBrand = (brand?: string, searchTerm?: string) => {
    return axios.get(MASTER_GET_URL + "/fetch-group/" + brand+"?search=" + searchTerm);
  };

  export const getProductByProductGroup = (brand?: string, product_group?:string, offset = 0, limit = 100) => {
    return axios.get(MASTER_GET_URL + "/fetch-group-product?brand=" + brand+"&product_group=" + product_group+"&offset=" + offset + "&limit=" + limit);
  };  

export const getProductByPowerGroup = (brand?: string, product_group?: string[], offset = 0, limit = 100) => {
    const productGroupParam = product_group ? JSON.stringify(product_group) : '';
    
    const url = MASTER_GET_URL + "/fetch-power-group";
    const params = {
        brand: brand,
        product_group: productGroupParam,
        offset: offset,
        limit: limit
    };
    
    console.log("API URL:", url);
    console.log("API Params:", params);
    
    return axios.get(url, { params });
};

export const restoreProduct = async (masterId: string, selectedProduct: string[]) => {
  return await axios.patch(`${RESTORE_PRODUCT_URL}/${masterId}`, {
    id: masterId,
    selectedProduct: selectedProduct
  });
};

export const syncAttribute = async (id: string, updateMasterDto: any) => {

    return await axios.post(SYNC_ATTRIBUTE_URL + id, updateMasterDto);
};